import React, { useEffect, useRef, useState } from 'react'
import NoData from '../../../global/ui/NoData';

interface IDetailsCribs {
    allData: Array<any>;
    onEdit?: (data: any) => void
    onDelete?: (data: any) => void
    role?: any
}

const DetailsCribs = (props: IDetailsCribs) => {

    const [openMenuId, setOpenMenuId] = useState<string | null>(null);

    const menuRef = useRef<HTMLDivElement>(null);

    // Close menu on outside click
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setOpenMenuId(null);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    if (props?.allData?.length <= 0) {
        return (
            <NoData message='No crib available.' />
        )
    }


    return (
        <div className="lcs-list">
            {props?.allData?.map(entry => (
                <div key={entry.id} className="lcs-entry">
                    <div className="lcs-entry__body">
                        <h4 className="lcs-entry__headline">{entry.headline}</h4>
                        <p className="lcs-entry__desc">{entry.description}</p>
                    </div>

                    {/* 3-dot menu */}
                    {props?.role != 'V' &&
                        <div className="lcs-entry__menu-wrap" ref={openMenuId === entry.id ? menuRef : null}>
                            <button
                                className="lcs-entry__menu-btn"
                                onClick={() => setOpenMenuId(openMenuId === entry.id ? null : entry.id)}
                                aria-label="Options"
                            >
                                <img src='/assets/images/dots-horizontal-rounded.svg' alt='more' />
                            </button>

                            {openMenuId === entry.id && (
                                <div className="lcs-entry__dropdown">
                                    <button
                                        className="lcs-entry__dropdown-item"
                                        onClick={() => {
                                            props?.onEdit?.(entry)
                                            setOpenMenuId(null);
                                        }}
                                    >
                                        <img src="/assets/images/edit-pencil-icon.svg" alt="" className="lcs-entry__dropdown-icon" />
                                        Edit Crib Sheet
                                    </button>
                                    <button
                                        className="lcs-entry__dropdown-item lcs-entry__dropdown-item--danger"
                                        onClick={() => {
                                            props?.onDelete?.(entry)
                                            setOpenMenuId(null);
                                        }}
                                    >
                                        <img src="/assets/images/trash-red-icon.svg" alt="" className="lcs-entry__dropdown-icon" />
                                        Delete Crib Sheet
                                    </button>
                                </div>
                            )}
                        </div>
                    }
                </div>
            ))}
        </div>
    )
}

export default DetailsCribs